// extracted by mini-css-extract-plugin
export default {"cancel-btn":"AddProductCategoryForm_cancel-btn__ErJYE","Add-Product-Category":"AddProductCategoryForm_Add-Product-Category__H3xvA"};